import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const ru: AppStrings = {
  // COMMON
  error_title: 'Ошибка',
  cancel: 'Отмена',
  retry: 'Повторить',
  back_arrow: '← Назад',

  // ASK SCREEN
  ask_box_unavailable: 'Ящик недоступен',
  ask_box_unavailable_desc: 'Похоже, ссылка устарела или автор закрыл ящик.',
  ask_create_own_box: 'Создать свой ящик',
  ask_sent_title: 'Отправлено ✅',
  ask_sent_desc: 'Анонимный вопрос ушёл автору ящика.',
  ask_anonymous_hint: 'Ваш вопрос отправится анонимно.',
  ask_placeholder: 'Напишите вопрос…',
  ask_send: 'Отправить',
  ask_sending: 'Отправка…',
  ask_error_rate_limit: 'Слишком часто, подождите минуту.',
  ask_error_restart: 'Перезапустите Mini App.',
  ask_error_load: 'Не удалось загрузить ящик.',
  ask_error_send: 'Не удалось отправить вопрос.',
  ask_error_banned: 'Вы заблокированы в приложении.',
  ask_banned_appeal_btn: 'Обжаловать',
  ask_appeal_sent: 'Апелляция отправлена. Мы рассмотрим её вручную.',

  // AGE GATE
  age_gate_title: 'Только для 18+',
  age_gate_desc:
    'Вы отправляете анонимный вопрос. Будьте уважительны: запрещены травля, угрозы, сексуальный контент в адрес несовершеннолетних и любой контент, нарушающий закон. Анонимность не означает безнаказанность — нарушения передаются модерации. Отправляя вопрос, вы подтверждаете, что вам есть 18 лет, и принимаете правила.',
  age_gate_confirm: 'Мне есть 18 — продолжить',

  // INBOX SCREEN
  inbox_title: 'Приём вопросов',
  box_link_accordion: 'Ссылка для приглашений',
  inbox_notifications_ask: '🔔 Разрешить боту присылать уведомления о новых вопросах?',
  inbox_notifications_allow: 'Разрешить',
  inbox_notifications_dismiss_label: 'Скрыть',
  inbox_box_toggle_disable: 'Выключить приём',
  inbox_box_toggle_enable: 'Включить приём',
  inbox_box_disabled_warning: 'Приём вопросов выключен — новые вопросы не принимаются.',
  inbox_share_hint: 'Поделись ссылкой — друзья смогут задать тебе анонимные вопросы.',
  inbox_copy: 'Скопировать',
  inbox_copied: 'Скопировано',
  inbox_copy_error: 'Ошибка',
  inbox_no_deeplink: 'Ссылка появится после deploy.',
  inbox_invite_story: 'Пригласить через Story',
  inbox_invite_chat: 'Пригласить через чат',
  inbox_card_rendering: 'Карточка-приглашение ещё рендерится.',
  inbox_story_unsupported:
    'Story недоступны в этой версии Telegram. Попробуй «через чат».',
  inbox_story_error: 'Не удалось открыть Story.',
  inbox_chat_unsupported:
    'Шеринг в чат недоступен в этой версии Telegram. Обнови клиент.',
  inbox_chat_error: 'Не удалось поделиться. Попробуй ещё раз.',
  inbox_chat_prepare_error: 'Не удалось подготовить приглашение.',
  inbox_filter_incoming: 'Входящие',
  inbox_filter_hidden: 'Скрытые',
  inbox_filter_blocked: 'Бан',
  inbox_filter_empty: 'Здесь пока пусто.',
  inbox_acc_unanswered: 'Неотвеченные',
  inbox_acc_answered: 'Отвеченные',
  inbox_acc_hidden: 'Скрытые',
  inbox_acc_blocked: 'Заблокированные',
  inbox_empty: 'Пока вопросов нет. Поделись ссылкой выше.',
  inbox_load_more: 'Загрузить ещё',
  inbox_load_more_error: 'Не удалось загрузить следующую страницу.',
  inbox_error_load: 'Не удалось загрузить ящик.',
  inbox_rate_limit: 'Слишком часто, подождите минуту.',
  inbox_toggle_error: 'Не удалось изменить статус ящика.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Напиши мне анонимно',
  message_placeholder: 'Напиши сообщение…',
  message_anonymous_hint: 'Твоё сообщение отправится анонимно.',
  message_sent_title: 'Отправлено ✅',
  message_sent_desc: 'Твоё анонимное сообщение доставлено.',
  message_owner_entry: 'Напиши мне',
  message_share_hint: 'Поделись ссылкой — и любой сможет прислать тебе анонимное сообщение.',
  message_inbox_open: 'Полученные сообщения',
  message_inbox_title: 'Сообщения',
  message_inbox_empty: 'Пока сообщений нет. Поделись ссылкой выше.',

  // ANSWER SCREEN
  answer_title: 'Ответ на вопрос',
  answer_placeholder: 'Напишите ответ…',
  answer_submit: 'Отправить',
  answer_submitting: 'Отправка…',
  answer_back: 'Назад',
  answer_error_send: 'Не удалось отправить ответ.',

  // SHARE SCREEN
  share_title: 'Ответ опубликован ✅',
  share_hint: 'Поделись карточкой и собери ещё больше вопросов.',
  share_card_rendering_desc:
    'Карточка ещё рендерится. Вернись к вопросам и загляни чуть позже — сможешь поделиться ей в Story или чате.',
  share_card_alt: 'Карточка ответа',
  share_story_btn: 'Поделиться в Story',
  share_story_btn_busy: 'Открываю…',
  share_chat_btn: 'Поделиться в чат',
  share_chat_btn_busy: 'Готовлю…',
  share_back: 'Вернуться к вопросам',
  share_story_unsupported:
    'Story недоступны в этой версии Telegram. Попробуй «Поделиться в чат».',
  share_story_error: 'Не удалось открыть Story. Попробуй «Поделиться в чат».',
  share_chat_sent: 'Сообщение отправлено.',
  share_chat_unsupported:
    'Шеринг в чат недоступен в этой версии Telegram. Обнови клиент.',
  share_chat_error: 'Не удалось поделиться. Попробуй ещё раз.',
  share_chat_prepare_error: 'Не удалось подготовить сообщение.',

  // LEADERBOARD SCREEN
  lb_title: 'Лидерборд',
  lb_period_7d: '7 дней',
  lb_period_30d: '30 дней',
  lb_period_all: 'Всё время',
  lb_group_label: 'Категория',
  lb_group_all: 'Все',
  lb_group_ask: 'Вопросы',
  lb_group_rate: 'Оценки',
  lb_group_confession: 'Признания',
  lb_group_guesswho: 'Угадай кто',
  lb_group_message: 'Сообщения',
  lb_error: 'Не удалось загрузить лидерборд',
  lb_empty: 'Пока никого в рейтинге',
  lb_anon: 'Аноним',
  lb_load_more: 'Загрузить ещё',
  lb_questions: (n) => `${n} вопр.`,
  lb_referrals: (n) => `${n} реф.`,

  // REWARDS SCREEN
  rw_title: 'Мои награды',
  rw_error: 'Не удалось загрузить награды',
  rw_level: (n) => `Уровень ${n}`,
  rw_confirmed_referrals: (n) => `${n} подтверждённых рефералов`,
  rw_next_level_section: (n) => `СЛЕДУЮЩИЙ УРОВЕНЬ — ${n} рефералов`,
  rw_to_level: (level, target) => `до уровня ${level}: ${target}`,
  rw_max_level: 'Максимальный уровень достигнут!',
  rw_badges_section: 'БЕЙДЖИ',
  rw_formats_section: 'ФОРМАТЫ ЯЩИКА',

  // QUESTION CARD
  qcard_status_new: 'Новый',
  qcard_status_hidden: 'Скрыт',
  qcard_status_answered: 'Отвечено',
  qcard_moderation_flagged: 'Осторожно, подозрительное сообщение',
  qcard_answer_btn: 'Ответить',
  qcard_answer_send: 'Отправить',
  qcard_share_btn: 'Поделиться',
  qcard_hide_btn: 'Скрыть',
  qcard_show_btn: 'Показать',
  qcard_report_btn: 'Пожаловаться',
  qcard_block_btn: 'Заблокировать',
  qcard_unblock_btn: 'Разблокировать',
  qcard_report_reason_label: 'Выберите причину жалобы:',
  qcard_reason_spam: 'Спам',
  qcard_reason_harassment: 'Травля',
  qcard_reason_sexual: 'Сексуальный контент',
  qcard_reason_other: 'Другое',
  qcard_error_hide: 'Не удалось изменить видимость.',
  qcard_error_report: 'Не удалось отправить жалобу.',
  qcard_error_block: 'Не удалось заблокировать отправителя.',
  qcard_report_done: 'Жалоба отправлена — спасибо.',
  qcard_block_done: 'Отправитель заблокирован.',
  qcard_unblock_done: 'Отправитель разблокирован.',

  // ERRORS (common humanized error messages)
  err_network: 'Нет связи с сервером. Проверьте интернет и попробуйте снова.',
  err_server_unavailable: 'Сервер временно недоступен, попробуйте позже.',
  err_internal: 'Что-то пошло не так. Мы уже знаем — попробуйте позже.',
  err_bad_request: 'Проверьте введённые данные.',
  err_generic: 'Не удалось выполнить действие, попробуйте позже.',
  err_schema: 'Ошибка данных. Попробуйте обновить приложение.',
  share_story_link_premium_note:
    'Ссылку в Story Telegram добавляет только с Telegram Premium. Без неё друзья всё равно найдут тебя — ник есть на карточке.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Ошибка доступа',
  auth_error_desc:
    'Не удалось авторизоваться. Пожалуйста, закройте и снова откройте Mini App через Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Новая награда!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Вопросы',
  tab_leaderboard: 'Лидерборд',
  tab_rewards: 'Награды',
  tab_settings: 'Настройки',

  // SETTINGS SCREEN
  settings_title: 'Настройки',
  settings_section_general: 'Основное',
  settings_notifications: 'Уведомления о новых вопросах',
  settings_notifications_hint: 'Бот будет присылать сообщение, когда тебе зададут вопрос.',
  settings_notifications_error: 'Не удалось сохранить настройку уведомлений.',
  settings_language: 'Язык',
  settings_language_error: 'Не удалось сменить язык. Попробуй ещё раз.',
  settings_section_about: 'О приложении',
  settings_version: 'Версия',

  // CODE ENTRY (work-020)
  code_modal_title: 'Ссылка в сторис — только для Premium',
  code_modal_explain:
    'Telegram даёт кликабельную ссылку в сторис только подписчикам Premium. Но вы можете добавить в сторис свой код — зрители введут его в приложении и зададут вам анонимный вопрос.',
  code_modal_your_code: 'Ваш код',
  code_modal_copy: 'Скопировать код',
  code_modal_copied: 'Скопировано',
  code_modal_share_btn: 'Поделиться в сторис',
  code_modal_loading: 'Готовим код…',
  code_modal_error: 'Не удалось получить код. Попробуйте позже.',
  ask_code_title: 'Введите код',
  ask_code_desc:
    'Если вы перешли из сторис — найдите в ней код (например, 1234) и введите ниже.',
  ask_code_placeholder: 'Код из сторис',
  ask_code_find: 'Найти',
  ask_code_not_found: 'Код не найден. Проверьте цифры и попробуйте снова.',
  ask_code_invalid: 'Код состоит из 4 цифр.',
  code_onboarding_header: 'Пришли из сторис?',
  code_onboarding_text: 'Введите код друга, чтобы задать ему анонимный вопрос.',
  code_onboarding_action: 'Ввести код',
  settings_ask_by_code: 'Спросить по коду',
  settings_my_code_title: 'Ваш код для сторис',
  settings_my_code_hint:
    'Напишите этот код в сторис — зрители введут его, чтобы задать вам анонимный вопрос. Кликабельную ссылку в сторис Telegram даёт только Premium-подписчикам.',
  settings_my_code_rotate: 'Получить новый код',
  settings_my_code_rotating: 'Меняем…',
  settings_my_code_done: 'Код обновлён',
  settings_my_code_error: 'Не удалось получить код.',
  settings_my_code_rotate_confirm_title: 'Сменить код?',
  settings_my_code_rotate_confirm_desc:
    'Старый код сразу перестанет работать. Кто видел его в вашей сторис — больше не сможет вас найти. Меняйте, только если вас спамят.',
  settings_my_code_rotate_confirm_action: 'Сменить код',

  // BOT
  bot_greeting: (name) => (name ? `Привет, ${name}! 👋` : 'Привет! 👋'),
  bot_onboarding:
    'Это VeylMe — анонимные вопросы.\n\n' +
    'Открой mini app, опубликуй карточку «Задай мне анонимный вопрос» в свою Story — ' +
    'и получай анонимные вопросы прямо сюда.\n\n' +
    '⚠️ 18+. Будь уважителен: травля, угрозы и запрещённый контент ' +
    'недопустимы. Анонимность ≠ безнаказанность — нарушения уходят модерации.',
  bot_open_btn: 'Открыть VeylMe',
  notify_answer_btn: 'Ответить',
  bot_invite_text:
    'Кто-то поделился ссылкой на VeylMe.\n\n' +
    'Открой mini app, чтобы задать анонимный вопрос:',
  bot_invite_btn: 'Спросить анонимно',

  // WORK-027 i18n sweep
  tagline: 'Задай мне анонимный вопрос',
  share_ask_action: 'Спросить',
  share_answered_text: 'Я ответил на анонимный вопрос 👀',
  err_not_in_telegram: 'Mini App не запущена в Telegram. Перезапустите приложение.',
  badge_viral_starter: 'Вирусный старт',
  badge_storyteller: 'Рассказчик',
  badge_loop_master: 'Мастер цикла',
  theme_confession: 'Признания',
  theme_guesswho: 'Угадай кто',
  rw_format_named: (name) => `формат «${name}»`,
  card_label_question: 'Вопрос',
  card_label_answer: 'Ответ',
  card_invite_subtitle: 'анонимно, без авторизации',
  card_code_hint: 'ВВЕДИ КОД В ПРИЛОЖЕНИИ',
  share_msg_title: (brand) => `${brand} · Анонимные вопросы`,
  notify_new_question: '🔔 Тебе задали анонимный вопрос',
  notify_unanswered_reminder: (n) =>
    plural('ru', n, {
      one: '🔔 У тебя {n} неотвеченный вопрос',
      few: '🔔 У тебя {n} неотвеченных вопроса',
      many: '🔔 У тебя {n} неотвеченных вопросов',
    }),
  notify_ban_permanent: 'навсегда',
  notify_ban_until: (date) => `до ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Вы заблокированы в VeylMe ${untilPhrase}. Слишком много получателей пожаловались на ваши сообщения.\nЕсли считаете это ошибкой — подайте апелляцию в приложении.`,
  notify_warning_msg:
    '⚠️ Несколько получателей пожаловались на ваши сообщения. Ещё немного — и вы будете заблокированы в VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Мои вопросы',
  my_questions_empty_title: 'Ты ещё не задавал вопросов',
  my_questions_empty_desc: 'Задай вопрос в чей-нибудь ящик — ответ появится здесь.',
  my_questions_loading: 'Проверяем, есть ли ответ…',
  my_questions_waiting: 'Ждёт ответа',
  my_questions_answer_label: 'Ответ',
  settings_my_questions: 'Мои вопросы',
  ask_sent_find_reply_hint: 'Ответ можно будет найти позже в разделе «Мои вопросы».',
  inbox_story_nonpremium_hint: 'Ссылка в Story не кликабельна без Telegram Premium, поэтому показываем код — отправить в чат надёжнее.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Пропуск Telegram устарел',
  session_expired_desc: 'Telegram выдаёт приложению пропуск один раз при запуске, и этот уже устарел. Откройте приложение заново — начатый текст мы сохранили.',
  session_expired_desc_no_storage: 'Пропуск Telegram устарел, приложение нужно открыть заново. Сохранить набранный текст не удалось — скопируйте его перед выходом.',
  session_expired_reopen: 'Открыть заново',
  session_expired_stuck_title: 'Telegram выдал тот же старый пропуск',
  session_expired_stuck_desc: 'Закройте приложение полностью через меню бота и откройте снова — тогда Telegram выдаст новый пропуск.',
  session_auth_failed_title: 'Не удалось подтвердить вход',
  session_auth_failed_desc: 'Telegram не подтвердил вход в приложение. Закройте приложение и откройте его заново из чата с ботом.',
  session_expired_manual_close: 'Закрыть приложение отсюда не получится — закройте его сами и откройте заново из чата с ботом.',
  session_expiring_soon: 'Пропуск Telegram скоро истечёт. Откройте приложение заново, чтобы ничего не потерять.',
  my_questions_check_failed: 'Не удалось проверить ответы. Попробуйте позже.',
  settings_notifications_load_error: 'Не удалось загрузить настройку.',
};
